import LearningPathway from '../LearningPathway';
import { AutocompleteModel, TraitTypeAutocomplete } from '../traits/autocomplete';

function traits() {
  return [
    {
      type: TraitTypeAutocomplete,
      model: AutocompleteModel.learningPathway,
      placeholder: 'Select a pathway...',
      label: 'Pathway',
      name: 'pathwayID',
      required: true,
    },
    {
      type: 'text',
      name: 'title',
      label: 'Title'
    },
    {
      type: 'text',
      name: 'estimated_time',
      label: 'Estimated time'
    }
  ];
}

function componentDefinition(editor, options) {
  const { componentType, componentName } = options;
  return {
    extend: 'react-component',
    model: {
      defaults: {
        'custom-name': componentName,
        component: LearningPathway,
        traits: traits(),
      },
    },
    isComponent: el => el.tagName === componentType.toUpperCase()
  }
}

export default function (editor, options = {}) {
  editor.Components.addType(options.componentType, componentDefinition(editor, options));
}
